export default __webpack_public_path__ + "static/media/icon-insights-email.5e558afe.svg";